import React from 'react';
import { T, sx } from '../lib/tokens';
import { Wordmark } from '../components/ui/Wordmark';
import { useIsMobile } from '../lib/useIsMobile';

export function About() {
  const m = useIsMobile();
  return (
    <LegalShell title="About receiptrec" m={m}>
      <h2 style={h2}>What is receiptrec</h2>
      <p style={p}>
        receiptrec is AI-powered receipt processing built exclusively for Xero. Forward,
        upload or snap a receipt and we extract every field, pick the right account, and
        create a Spend Money transaction with the source file attached.
      </p>

      <h2 style={h2}>Who made it</h2>
      <p style={p}>
        We're the team at Crewamp, based in Melbourne, Australia. We build practical
        AI tools for small businesses that want their time back.
      </p>

      <h2 style={h2}>Why</h2>
      <p style={p}>
        We got sick of Sunday-night admin sessions - forwarding every receipt by hand,
        typing vendors into Xero, hunting for the right account code. If a computer can do
        that, a computer should do that.
      </p>

      <h2 style={h2}>Contact</h2>
      <p style={p}>
        Say hi at <a href="mailto:hello@receiptrec.com" style={a}>hello@receiptrec.com</a>.
      </p>
    </LegalShell>
  );
}

const p: React.CSSProperties = { fontSize: 16, lineHeight: 1.6, color: T.graphite, margin: '0 0 18px' };
const h2: React.CSSProperties = { ...sx.serif, fontSize: 26, letterSpacing: '-0.015em', fontWeight: 400, margin: '36px 0 14px', color: T.graphite };
const a: React.CSSProperties = { color: T.sageDarker, textDecoration: 'underline' };

function LegalShell({ title, subtitle, m, children }: { title: string; subtitle?: string; m: boolean; children: React.ReactNode }) {
  return (
    <div style={{ background: T.paper, color: T.graphite, minHeight: '100vh' }}>
      <header style={{ position: 'sticky', top: 0, zIndex: 10, background: T.navy, borderBottom: `1px solid ${T.navyLine}` }}>
        <div style={{ maxWidth: 1240, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: m ? '14px 20px' : '18px 40px' }}>
          <a href="#/" style={{ textDecoration: 'none' }}><Wordmark size={m ? 20 : 24} /></a>
          <a href="#/" style={{ fontSize: 14, color: T.creamMuted, textDecoration: 'none' }}>Back to home</a>
        </div>
      </header>
      <main style={{ maxWidth: 720, margin: '0 auto', padding: m ? '32px 20px' : '60px 40px' }}>
        <h1 style={{ ...sx.serif, fontSize: m ? 32 : 48, lineHeight: 1.05, letterSpacing: '-0.03em', fontWeight: 400, margin: '0 0 10px' }}>{title}</h1>
        {subtitle && <div style={{ fontSize: 13, color: T.graphiteDim, marginBottom: 28 }}>{subtitle}</div>}
        {children}
      </main>
    </div>
  );
}
